import React, { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthContext } from "./AuthProvider";

export function Logout() {
	const { clearUserData } = useContext(AuthContext);
	const navigate = useNavigate();
	const [params, setParams] = useSearchParams();

	const logout = () => {
		clearUserData();
		navigate(`/?${params.toString()}`);
	};
	useEffect(() => {
		logout();
	}, []);
	return (
		<React.Fragment>
			<div>logging out!!!</div>
		</React.Fragment>
	);
}
